import { render, staticRenderFns } from "./base_item.vue?vue&type=template&id=00aa226c&scoped=true&"
import script from "./base_item.vue?vue&type=script&lang=js&"
export * from "./base_item.vue?vue&type=script&lang=js&"
import style0 from "./base_item.vue?vue&type=style&index=0&id=00aa226c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00aa226c",
  null
  
)

export default component.exports